<button [type]="buttonType" [class]="buttonClasses">
  <ng-content></ng-content>
</button>